import api from "./api";
import { endpoints } from "./endpoints";
import { normalizeUser } from "../utils/user";
import { toNum } from "../utils/format"

export async function login(identification, password) {
  const { data } = await api.post(endpoints.auth.login, { identification, password });
  const token = data?.access_token ?? data?.token;
  const rawUser = data?.user ?? {};
  const user = normalizeUser(rawUser);
  return { token, user };
}

export async function resolveCompanyFromLocalOrApi() {
  // 1) Intento con localStorage
  let localUser = null;
  try {
    const raw = localStorage.getItem("user");
    localUser = raw ? JSON.parse(raw) : null;
  } catch (_) {
    // si falla el parse, seguimos con null
  }

  if (localUser) {
    const localId = toNum(
      localUser?.company?.id ?? localUser?.companyId ?? localUser?.company_id
    );
    const localName =
      localUser?.company?.name ??
      localUser?.companyName ??
      localUser?.company_name ??
      null;

    if (localId !== null) {
      return { id: localId, name: localName || "—" };
    }
  }

  // 2) Fallback: pedir el usuario al backend
  const uid = toNum(localUser?.id ?? localUser?.userId ?? localUser?.user_id);
  if (uid === null) {
    throw new Error("Usuario inválido (no se pudo resolver el ID).");
  }

  const r = await api.get(endpoints.users.byId(uid));
  const data = r?.data?.data ?? r?.data ?? {};

  const apiCompanyId = toNum(
    data?.company?.id ?? data?.companyId ?? data?.company_id
  );
  const apiCompanyName =
    data?.company?.name ?? data?.companyName ?? data?.company_name ?? null;

  if (apiCompanyId === null) {
    throw new Error("El usuario no tiene empresa asignada.");
  }

  return { id: apiCompanyId, name: apiCompanyName || "—" };
}